import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RentedCar, CreateRentedCarDto, UpdateRentedCarDto, CarExtraCharge, CreateCarExtraChargeDto, CostSummary } from '../models/rented-car.model';
import { apiBase } from './api-config';

@Injectable({ providedIn: 'root' })
export class RentedCarService {
  private http = inject(HttpClient);
  private base = `${apiBase}/cars`;

  getAll(): Observable<RentedCar[]> {
    return this.http.get<RentedCar[]>(this.base);
  }

  getById(id: number): Observable<RentedCar> {
    return this.http.get<RentedCar>(`${this.base}/${id}`);
  }

  create(dto: CreateRentedCarDto): Observable<RentedCar> {
    return this.http.post<RentedCar>(this.base, dto);
  }

  update(id: number, dto: UpdateRentedCarDto): Observable<RentedCar> {
    return this.http.put<RentedCar>(`${this.base}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }

  getExtraCharges(carId: number): Observable<CarExtraCharge[]> {
    return this.http.get<CarExtraCharge[]>(`${this.base}/${carId}/extra-charges`);
  }

  addExtraCharge(carId: number, dto: CreateCarExtraChargeDto): Observable<CarExtraCharge> {
    return this.http.post<CarExtraCharge>(`${this.base}/${carId}/extra-charges`, dto);
  }

  getCostSummary(carId: number, from: string, to: string): Observable<CostSummary> {
    const params = new HttpParams().set('from', from).set('to', to);
    return this.http.get<CostSummary>(`${this.base}/${carId}/cost-summary`, { params });
  }
}
